import React, { useEffect, useState } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { Box, Backdrop, CircularProgress } from "@mui/material";

const Spinner = () => {
  const { promiseInProgress } = usePromiseTracker();
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    let timeout;

    if (promiseInProgress) {
      setShowSpinner(true);
    } else {
      timeout = setTimeout(() => {
        setShowSpinner(false);
      }, 100);
    }

    return () => clearTimeout(timeout);
  }, [promiseInProgress]);

  return (
    showSpinner && (
      <>
        <Backdrop open sx={{ zIndex: 9999, backgroundColor: "rgba(252, 253, 247, 0.5)" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        </Backdrop>
      </>
    )
  );
};
export default Spinner;